module.exports = __webpack_public_path__ + "static/media/account-ilustra2.34735004.png";